import {
  CreateUserInput,
  UpdateUserInput,
  UseGenerativeAIOptions,
  UseGenerativeAIOptionsInput,
  User,
} from '@akin-home/amplify';
import { filterHasValue, notNull } from '@akin-home/arrays';
import { UserModel, UserRef } from '@akin-home/user';
import { v4 as uuid } from 'uuid';

export const graphqlUserToModel = (user: User): UserModel => ({
  securityGroups: [],
  ...user,
  id: user.id as string,
  name: user.name || '',
  sub: user.sub as string,
  habitatID: user.habitatID as string,
  email: user.email || '',
  username: user.username || '',
  favourite_recipe_ids: filterHasValue(user.favourite_recipe_ids),
});

export const grapqhlUserToUserRef = (user: User): UserRef => ({
  id: user.id as string,
  name: user.name as string,
  habitatID: user.habitatID as string,
  imageUrl: user.customPictureURL || undefined,
  image: notNull(user.image),
  profileColor: user.profileColor || undefined,
  profilePicture: user.profilePicture,
});

export const userModelToUserRef = (user: UserModel): UserRef => ({
  id: user.id,
  name: user.name,
  habitatID: user.habitatID,
  imageUrl: user.customPictureURL || undefined,
  image: notNull(user.image),
  profileColor: user.profileColor || undefined,
  profilePicture: user.profilePicture,
});

export const formatUseGenerativeAIToGraphql = (
  opts?: UseGenerativeAIOptions
): UseGenerativeAIOptionsInput | null =>
  opts
    ? {
        name: opts.name,
        max_tokens: opts.max_tokens || null,
        temperature: opts.temperature || null,
      }
    : null;

export const userModelToCreateGraphql = (user: UserModel): CreateUserInput => ({
  name: user.name,
  habitatID: user.habitatID,
  username: user.username,
  email: user.email,
  sub: user.sub,
  phoneNumber: user.phoneNumber,
  carerName: user.carerName,
  carerPhone: user.carerPhone,
  NDISAccountName: user.NDISAccountName,
  NDISNumber: user.NDISNumber,
  onboardingToken: uuid(),
  hasOnboarded: false,
  is_child_profile: user.is_child_profile,
  use_generative_ai: formatUseGenerativeAIToGraphql(
    user.use_generative_ai || undefined
  ),

  /** Image fields */
  imageID: user.image?.id || null,
  profilePicture: user.profilePicture,
  profileColor: user.profileColor,
  customPictureURL: user.customPictureURL,
});

export const userModelToUpdateGraphql = (user: UserModel): UpdateUserInput => ({
  ...userModelToCreateGraphql(user),
  id: user.id,
});
